import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultQuery: '=',
        filter: '=',
        state: '=',
        questionIds: '=?',
        showRandomizedFilter: '='
    },
    template: `
        <form ng-submit="vm.applyFilter()" class="table-filters">
            <div class="form form-filter">
                <div class="fields">
                   <form-row error="vm.filter.errors.externalId">
                        <label class="label">{{ 'questions.ID' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.externalId" type="text" class="form-control">
                        </div>
                        <form-row-error></form-row-error>
                    </form-row>
                    <div ng-if="vm.state && vm.state === 'allQuestions'" class="row">
                      <label class="label">{{ 'questions.Pool' | translate }}</label>
                      <div class="items">
                        <select class="form-control"
                                ng-model="vm.filter.questionPoolId"
                                ng-change="vm.updateCategorySelect()"
                                ng-options="pool.id as pool.name for pool in vm.questionPools track by pool.id">
                          <option value="">-</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'questions.Category' | translate }}</label>
                        <div class="ac02" uib-dropdown keyboard-nav>
                            <input autocomplete="off" class="form-control" ng-change="vm.search()" ng-model="vm.categoryNameKeyword" type="text"
                             placeholder="{{ 'search.Find a category...' | translate }}" id="category" uib-dropdown-toggle>
                                <ul class="results01" uib-dropdown-menu role="menu" aria-labelledby="searchkey">
                                    <li class="heading" ng-if="vm.getIsNoResults()">{{ 'search.No results' | translate }}</li>
                                    <li class="heading" ng-if="!vm.categoryNameKeyword.length">{{ 'search.Type to search' | translate }}</li>
                                    <li class="heading" ng-if="vm.categories.length">{{ 'search.Categories' | translate }}</li>
                                    <li class="divider"></li>
                                    <li ng-repeat="category in vm.categories">
                                        <a ng-click="vm.selectCategory(category)">{{ category.name }}</a>
                                    </li>
                                </ul>
                        </div>
                    </div>
                    <form-row error="vm.filter.errors.keyword">
                        <label class="label">{{ 'questions.Keyword' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.keyword" type="text" class="form-control">
                        </div>
                        <form-row-error></form-row-error>
                    </form-row>
                    <div class="row">
                        <label class="label">{{ 'questions.Author' | translate }}</label>
                        <div class="items">
                          <select class="form-control"
                                  ng-disabled="!vm.companyUsers.length"
                                  ng-model="vm.filter.authorId"
                                  ng-options="user.id as user.displayName for user in vm.companyUsers track by user.id">
                            <option value=""></option>
                          </select>
                        </div>
                    </div>
                    <div class="row" ng-if="vm.showRandomizedFilter">
                        <span class="label">{{ 'questions.Random selection' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" ng-change="vm.toggleRandomFilter()" ng-model="vm.filter.isRandomizedOrder" name="switch">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                            </div>
                    </div>
                    <div class="row" ng-if="vm.filter.isRandomizedOrder">
                        <label class="label">{{ 'questions.Amount of questions' | translate }}</label>
                        <div class="items">
                            <input type="number" ng-model="vm.filter.amountOfQuestions" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="fields02" ng-if="vm.advanced==true">
                    <div class="items">
                        <div ng-repeat="meta in vm.filter.metaSearch" class="row row-full row-flex">
                            <div class="items">
                              <select class="form-control"
                                      ng-model="vm.filter.metaSearch[$index].metaFieldId"
                                      ng-change="vm.updateMetaFilter($index)"
                                      ng-options="meta.id as meta.name for meta in vm.companyMetaFields track by meta.id">
                              </select>
                            </div>
                            <div class="items" ng-if="vm.filter.metaSearch[$index].type === vm.FORMS_META_FIELD_TYPE_ENUM.KEYS.FREE_TEXT">
                                <input
                                  ng-if="vm.filter.metaSearch[$index].type === vm.FORMS_META_FIELD_TYPE_ENUM.KEYS.FREE_TEXT"
                                  ng-model="vm.filter.metaSearch[$index].metaFieldValue"
                                  type="text"
                                  class="form-control"
                                >
                            </div>
                            <div class="items" ng-if="vm.filter.metaSearch[$index].type === vm.FORMS_META_FIELD_TYPE_ENUM.KEYS.SELECT">
                              <select class="form-control"
                                      ng-model="vm.filter.metaSearch[$index].metaFieldValueId"
                                      ng-options="meta.id as meta.value for meta in vm.filter.metaSearch[$index].activeLanguageValues track by meta.id">
                              </select>
                            </div>
                            <a class="btn delete"
                                 ng-if="$index !== 0"
                                 ng-click="vm.removeValueRow($index)">{{ 'general.Delete' | translate }}</a>
                            <a class="btn add" ng-if="$last" ng-click="vm.addValueRow()">{{ 'general.Add' | translate }}</a>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li ng-if="vm.advanced==false"><a class="btn filter" ng-click="vm.advanced=!vm.advanced">{{ 'forms.Show advanced fields' | translate }}</a></li>
                    <li ng-if="vm.advanced==true"><a class="btn filter" ng-click="vm.advanced=!vm.advanced">{{ 'forms.Hide advanced fields' | translate }}</a></li>
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'general.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($translate, lodash, FORMS_POOL_ENUM, FORMS_META_FIELD_TYPE_ENUM, QuestionPoolResource, MetaFieldResource, UserResource, QuestionCategoryResource, TokenService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.FORMS_META_FIELD_TYPE_ENUM = FORMS_META_FIELD_TYPE_ENUM;
        this.QuestionCategoryResource = QuestionCategoryResource;
        this.QuestionPoolResource = QuestionPoolResource;
        this.UserResource = UserResource;
        this.MetaFieldResource = MetaFieldResource;
        this.categoryNameKeyword = '';
        this.searchCompleted = false;
        this.advanced = false;
        this.activeLanguage = TokenService.getActiveLanguage();

        this.categories = {};

        this.filter.errors = {};
    }

    $onInit () {
        this.MetaFieldResource.query({ pageSize: 0, expand: 'metaFieldValuesI18ns' }).$promise.then((response) => {
            this.companyMetaFields = response;
        });

        this.UserResource.query({
            pageSize: 0,
            questionAuthors: true
        }).$promise.then((response) => {
            this.companyUsers = response;
        });

        if (this.state && this.state === 'allQuestions') {
            this.QuestionPoolResource.query({ status: this.FORMS_POOL_ENUM.KEYS.ACTIVE, pageSize: 0 }).$promise.then((response) => {
                this.questionPools = response;
            });
        }

        if (!this.filter.metaSearch) {
            this.filter.metaSearch = [];
            this.addValueRow();
        }
        else {
            this.filter.metaSearch = JSON.parse(this.filter.metaSearch);
            this.advanced = true; // if we have meta open advanced search
        }

        if (this.filter.categoryId) {
            this.QuestionCategoryResource.get({ id: this.filter.categoryId }).$promise.then((response) => {
                this.categoryNameKeyword = response.name; // set category for autocomplete
            });
        }
    }

    toggleRandomFilter () {
        if (!this.filter.isRandomizedOrder) {
            this.filter.amountOfQuestions = null;
            this.filter.pageSize = this.defaultQuery.pageSize;
            this.applyFilter();
        }
    }

    addValueRow () {
        this.filter.metaSearch.push({});
    }

    removeValueRow (index) {
        this.filter.metaSearch.splice(index, 1);
    }

    applyFilter () {
        this.filter.errors = {};
        this.questionIds = [];
        if (this.validateKeyword()) {
            this.filterCopy = angular.copy(this.filter);
            if (this.filterCopy.metaSearch) {
                // as object will be sent as query param, we send it as json
                this.filterCopy.metaSearch = JSON.stringify(this.filterCopy.metaSearch);
            }

            if (this.filterCopy.amountOfQuestions) {
                this.filterCopy.pageSize = this.filterCopy.amountOfQuestions;
            }

            this.list.fetch(this.filterCopy);
        }
    }

    resetFilter () {
        this.filter = this.lodash.assign({}, this.defaultQuery);
        this.categoryNameKeyword = '';
        this.selectedAuthor = null;
        delete this.list.sort;
        if (!this.filter.metaSearch) {
            this.filter.metaSearch = [];
            this.addValueRow();
        }
        this.list.fetch(this.defaultQuery);
    }

    updateMetaFilter ($index) {
        const meta = this.lodash.find(this.companyMetaFields, (item) => {
            return item.id === parseInt(this.filter.metaSearch[$index].metaFieldId, 10);
        });

        this.filter.metaSearch[$index].type = meta.type;
        this.filter.metaSearch[$index].activeLanguageValues = this.lodash.filter(meta.metaFieldValuesI18ns, (metaFieldValue) => {
            return metaFieldValue.language === this.activeLanguage;
        });
    }

    validateKeyword () {
        // validate for keyword to have at least 2 characters
        if (this.filter.keyword && this.filter.keyword.length > 0 && this.filter.keyword.length < 2) {
            this.filter.errors.keyword = this.$translate.instant('questionFilter.Keyword have to be at least 2 characters long.');
            return false;
        }
        return true;
    }

    search () {
        if (!this.categoryNameKeyword.length) {
            this.filter.categoryId = null;
            this.categories = {};
            return;
        }
        this.filter.categoryId = null;
        this.QuestionCategoryResource.query({ keyword: this.categoryNameKeyword, pageSize: 0 }).$promise.then((response) => {
            this.categories = response;
            this.searchCompleted = true;
        });
    }

    getIsNoResults () {
        return this.categoryNameKeyword.length && !this.categories.length && this.searchCompleted;
    }

    selectCategory (category) {
        this.filter.categoryId = category.id;
        this.categoryNameKeyword = category.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/filter/index.js